export const LEASE_DETAILS_PAGE = 1
export const LEASE_PRICING_PAGE = 2
export const LEASE_INCENTIVES_PAGE = 3
export const LEASE_SERVICES_AND_UTILITIES_PAGE = 4
export const LEASE_DOCUMENT_TEMPLATES_PAGE = 5
export const LEASE_ADDITIONAL_INFORMATION_PAGE = 6
export const LEASE_SUMMARY_PAGE = 7
export const LEASE_PREVIEW_PAGE = 8

export const ADDITIONAL_CHARGES = 'additional_charges';
export const ADDITIONAL_FIELDS = 'additional_fields';

export const LEASE_TYPE = 'lease';
export const FIXED_ADDENDUM = 'fixed_addendum';
export const CONDITIONAL_ADDENDUM = 'conditional_addendum';

export const extractSuffix = (label, type, documentTemplateTitle = undefined) => {
  if (!documentTemplateTitle) {
    return label.replace(` [${type}]`, '');  
  }
  return label.replace(` (${documentTemplateTitle}) [${type}]`, '');
}